// frontend/src/api/ordenes_compra.js
import API from './axios';

const clean = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

export const fetchOrdenesCompra = ({ page = 1, pageSize = 10 } = {}) =>
  API.get('/ordenes_compra', { params: { page, pageSize } }).then(res => res.data);

export const fetchOrdenCompra = (id) =>
  API.get(`/ordenes_compra/${id}`).then(res => res.data);

export const createOrdenCompra = (data) =>
  API.post('/ordenes_compra', data).then(res => res.data);

export const updateOrdenCompra = (id, data) =>
  API.put(`/ordenes_compra/${id}`, data).then(res => res.data);

export const deleteOrdenCompra = (id) =>
  API.delete(`/ordenes_compra/${id}`);

export const searchOrdenesCompra = ({ codigo, fecha,sku, page = 1, pageSize = 10 }) =>
  API.get('/ordenes_compra/search', { params: { codigo, fecha, sku, page, pageSize } })
     .then(r => r.data);

export const fetchOrdenCompraResumenByCodigo = (codigo) =>
  API.get(`/ordenes_compra/codigo/${encodeURIComponent(codigo)}/resumen`).then(res => res.data);

export const fetchOrdenCompraDetalleByCodigo = (codigo) =>
  API.get(`/ordenes_compra/codigo/${encodeURIComponent(codigo)}/detalle`).then(res => res.data);

export const fetchOrdenCompraConsultaByCodigo = (codigo) =>
  API.get(`/ordenes_compra/codigo/${encodeURIComponent(codigo)}/consulta`).then(res => res.data);

export const downloadOrdenCompraDetalleCsvByCodigo = async (codigo, params = {}) => {
  const res = await API.get(`/ordenes_compra/codigo/${encodeURIComponent(codigo)}/detalle.csv`, {
    params: clean(params),
    responseType: 'blob',
  });
  return res.data;
};
